import React, { useState } from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import EventCard from "./EventCard";

const CalendarEventListing = ({
  filteredEvents,
  selectedEvent,
  expandedAccordions,
  editEventCalendarDetails,
  executeEventDeleteAction,
  handleAccordionChange,
  listRef,
  playerData,
  participantsOpen,
  setParticipantsOpen,
  participantList,
  participantsCollapseChange,
  viewPlayerProfile,
}) => {
  return (
    <Card sx={{ mb: "2rem" }}>
      <CardContent
        sx={{
          padding: "0px",
          "&:last-child": {
            paddingBottom: "0px",
          },
        }}
      >
        {filteredEvents.length === 0 ? (
          <>
            <Grid container p={3}>
              <Grid item lg={12}>
                <Typography>
                  No events found for the selected date range.
                </Typography>
              </Grid>
            </Grid>
          </>
        ) : (
          <div ref={listRef}>
            {filteredEvents.map((event) => (
              <EventCard
                key={event.eventId}
                event={event}
                selectedEvent={selectedEvent}
                expandedAccordions={expandedAccordions}
                handleAccordionChange={handleAccordionChange}
                participantsCollapseChange={participantsCollapseChange}
                editEventCalendarDetails={editEventCalendarDetails}
                executeEventDeleteAction={executeEventDeleteAction}
                playerData={playerData}
                participantsOpen={participantsOpen}
                setParticipantsOpen={setParticipantsOpen}
                participantList={participantList}
                viewPlayerProfile={viewPlayerProfile}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default CalendarEventListing;
